enum SecondaryPhoneNumberActionsEnum {
    Add = 'Add',
    Edit = 'Edit',
    Remove = 'Remove',
    MakeDefault = 'Make Default',
}

export default SecondaryPhoneNumberActionsEnum;
